import API from './index';
import { User } from '../types/auth';

interface RegisterResponse {
  accessToken: string;
  expiresIn: number;
  tokenType: string;
}

export const register = async (
  email: string,
  password: string,
  referrerCode?: string,
): Promise<RegisterResponse> => {
  const data: RegisterResponse = await API.post('/auth/register', {
    email,
    password,
    referrerCode,
    userType: 'personal',
  });
  return data;
};

interface LoginResponse {
  accessToken: string;
  referralCode: string;
  expiresIn: number;
  tokenType: string;
}

export const login = async (email: string, password: string): Promise<LoginResponse> => {
  const data: LoginResponse = await API.post('/auth/login', { email, password });
  return data;
};

export const logout = async (): Promise<[]> => {
  const data: [] = await API.post('/auth/logout');
  return data;
};

export const forgotPassword = async (email: string): Promise<[]> => {
  const data: [] = await API.post('/auth/reset-password-request', { email });
  return data;
};

export const resetPassword = async (token: string, password: string): Promise<[]> => {
  const data: [] = await API.post('/auth/reset-password', { token, password });
  return data;
};

export const getUserInfo = async (): Promise<User> => {
  const data: User = await API.get('/customer/info');
  return data;
};

export const getHubSpotToken = async (): Promise<string> => {
  const { token } = await API.get(`/customer/hubspot-token`);
  return token;
};
